import { render, staticRenderFns } from "./ConfigurationSummary.vue?vue&type=template&id=136e2995"
import script from "./ConfigurationSummary.vue?vue&type=script&lang=js"
export * from "./ConfigurationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports